import request from "superagent";
import networkLogger from "../networkLogger";
import { graphQLRequestIAM } from '../graphQLService';

const BadgingUrl = process.env.GAME_REWARD_SERVICE_URL;

/**
 * http helper for sending GraphQL requests to the badging/game reward service
 * @param {string} query - GraphQL query
 * @param {object} variables - GraphQL query variables
 * @returns {Promise<*>}
 */
async function graphqlRequest(query, variables) {
  const startTime = Date.now();
  try {
    const response = await graphQLRequestIAM(BadgingUrl, query, variables, 3);
    const duration = Date.now() - startTime;

    if (response.errors) {
      console.log(response.errors);
      networkLogger.logGraphQLError(
        'BadgingService',
        BadgingUrl,
        null,
        response.errors,
        duration
      );
      const graphqlError = new Error(response.errors[0].message);
      graphqlError.isGraphQLError = true;
      throw graphqlError;
    }

    return response.data;
  } catch (error) {
    if (!error.isGraphQLError) {
      networkLogger.logGraphQLError(
        'BadgingService',
        BadgingUrl,
        null,
        error,
        Date.now() - startTime
      );
    }
    throw error;
  }
}

export default graphqlRequest;